export default __webpack_public_path__ + "static/media/Icon material-dashboard.098e82d1.svg";